import TilesView from './TilesView';

export default TilesView;